<template>
  <div>
    <el-container>
      <el-header>
        <BaseHeader
          @updateRoleInfo="updateRoleInfo"
          ref="baseHeaderRef"
        ></BaseHeader>
      </el-header>
      <div style="overflow: auto; height: calc(100vh - 60px)">
        <el-main
          :style="{ padding: ifHidePadding ? '0px' : '', 'min-height': '100%' }"
          class="base-main"
        >
          <router-view style="flex: 1"></router-view>
        </el-main>
        <el-footer height="100px">
          <BaseFooter></BaseFooter>
        </el-footer>
      </div>
    </el-container>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  computed,
  onMounted,
  provide,
} from "vue";
import { httpPost } from "@/api/httpService.js";
import BaseHeader from "./BaseHeader.vue";
import BaseFooter from "./BaseFooter.vue";
import { useRoute, useRouter } from "vue-router";

const baseHeaderRef = ref(null);
const roleInfo = ref();

const route = useRoute();
const ifHidePadding = computed(() => {
  return route.meta.ifHidePadding;
});
const updateRoleInfo = (val) => {
  roleInfo.value = val;
};
provide("roleInfo", roleInfo);
</script>

<style lang="scss" scoped>
.base-main {
  background: $main-background;
}
.el-footer {
  background: $main-background;
}
</style>
